export default "__VITE_ASSET__57917651__"